import $ from "jquery";

export class toggleText {
  constructor($el) {
    this.$el = $el;
    this.$toggleButton = this.$el.find(".toggleButton");
    this.$moreText = this.$el.find(".toggle-description");
    this.$isShown = this.$moreText.attr("data-toggle-more-text");
    this.numberOfParagraphs = this.$moreText.find("p").length;
    this.pheight = 0;
    this.maxHeight = 0;
    this.heightToTheMax = parseInt(this.$moreText.css("max-height"));
    this.overflow = this.$moreText.css("overflow");
    this.heightAtStart = this.$moreText.css("height");
    this.hidingText = false;
    this.bindEvents();
  }
  // Add a click event listener to the button

  bindEvents() {
    var thisListing = this;

    ResizeMaxHeight();
    CheckIfTextIsHidden();
    ToggleMoreTest(thisListing.$isShown);

    $(window).on("resize", function () {
      if ((thisListing.$isShown = "true")) {
        ToggleMoreTest(thisListing.$isShown);
      }
      ResizeMaxHeight();
      CheckIfTextIsHidden();
    });

    function ResizeMaxHeight() {
      thisListing.pheight = 0;

      if (thisListing.numberOfParagraphs > 1) {
        for (let i = 0; i < thisListing.numberOfParagraphs; i++) {
          if (
            thisListing.heightToTheMax <
            thisListing.pheight +
              $(thisListing.$moreText.find("p").eq(i)).outerHeight(true)
          ) {
            if (i == 0) {
              thisListing.pheight = $(
                thisListing.$moreText.find("p").eq(i)
              ).outerHeight(true);
            }
            break;
          }
          thisListing.pheight += $(
            thisListing.$moreText.find("p").eq(i)
          ).outerHeight(true);
        }
        thisListing.maxHeight = thisListing.pheight;
      } else {
        thisListing.maxHeight = thisListing.heightToTheMax;
      }
    }

    function CheckIfTextIsHidden() {
      let scrollH = $(thisListing.$moreText).prop("scrollHeight");
      let clientH = $(thisListing.$moreText).prop("clientHeight");

      if (scrollH > clientH) {
        thisListing.hidingText = true;
        HideCollapseButton(0);
      } else {
        thisListing.hidingText = false;
        HideCollapseButton(1);
      }
    }

    function HideCollapseButton(tf) {
      if (tf == 0) {
        thisListing.$toggleButton.css("display", "block");
      } else {
        thisListing.$toggleButton.css("display", "none");
      }
    }

    function ToggleMoreTest(tf) {
      if (tf == 0) {
        // If it's NOT visible, show the rest of text and change the button text
        thisListing.$moreText.css("overflow", "visible");
        thisListing.$moreText.css("max-height", "none");
        // thisListing.$moreText.css("height", "auto");
        thisListing.$moreText.css("display", "block");
        thisListing.$toggleButton.text("« Collapse");
        thisListing.$isShown = true;
        thisListing.$moreText.attr("data-toggle-more-text", true);
      } else {
        // If it's showing, hide change the button text
        thisListing.$moreText.css("overflow", thisListing.overflow);
        thisListing.$moreText.css("max-height", thisListing.maxHeight);
        // thisListing.$moreText.css("height", thisListing.heightAtStart);
        thisListing.$toggleButton.text("Continue Reading »");
        thisListing.$isShown = false;
        thisListing.$moreText.attr("data-toggle-more-text", false);
      }
    }

    thisListing.$toggleButton.on("click", () => {
      // Check if the "more" text is currently displayed
      ToggleMoreTest(thisListing.$isShown);
    });
  }
}
